import * as pagination from './pagination'
import * as baseStore from './baseStore'
import * as project from './project'
import * as users from './users'
import * as authenticate from './authenticate'
import * as stabSchematisation from './stabSchematisation'
import * as riverWaterLevel from './riverWaterLevel'
import * as settlement from './settlement'
import * as crestLevelBoundaryCondition from './crestLevelBoundaryCondition'
import * as hydraulicHeadBoundaryCondition from './hydraulicHeadBoundaryCondition'
import * as burstingParameterRevision from './burstingParameterRevision'
import * as burstingParameter from './burstingParameter'
import * as topoProfile from './topoProfile'
import * as dikeSection from './dikeSection'
import * as topoProfilePoint from './topoProfilePoint'
import * as baseSoilType from './baseSoilType'
import * as soilTypeRevision from './soilTypeRevision'
import * as soilType from './soilType'
import * as suTable from './suTable'
import * as suTablePoint from './suTablePoint'
import * as stageConfiguration from './stageConfiguration'
import * as stageConfigurationRevision from './stageConfigurationRevision'
import * as referencePoint from './referencePoint'
import * as dikeProfiles from './dikeProfiles'
import * as multiplePhreaticLine from './multiplePhreaticLine'
import * as phreaticLine from './phreaticLine'
import * as phreaticReferenceLine from './phreaticReferenceLine'
import * as headLine from './headLine'
import * as headReferenceLine from './headReferenceLine'
import * as multipleHeadLine from './multipleHeadLine'
import * as soilProfile from './soilProfile'
import * as soilProfilePoint from './soilProfilePoint'
import * as soilLine from './soilLine'
import * as soilLayer from './soilLayer'
import * as stabSchematisationStage from './stabSchematisationStage'
import * as uniformLoads from './uniformLoads'
import * as treeLoads from './treeLoads'
import * as baseDirtyFields from './baseDirtyFields'
import * as statePoints from './statePoints'
import * as years from './years'
import * as userManagement from './userManagement'
import * as reinforcement from './reinforcement'
import * as reinforcementGenerate from './reinforcementGenerate'
import * as reinforcementPoint from './reinforcementPoint'
import * as overview from './overview'
import * as load from './load'
import * as waterLineRule from './waterLineRule'
import * as waterLineRuleRevision from './waterLineRuleRevision'
import * as webSocket from './webSocket'
import * as comment from './comment'
import { createStore } from 'vuex'

const store = createStore({
  strict: false,
  modules: {
    baseStore,
    baseDirtyFields,
    pagination,
    uniformLoads,
    project,
    dikeSection,
    treeLoads,
    dikeProfiles,
    referencePoint,
    users,
    authenticate,
    stabSchematisationStage,
    stabSchematisation,
    riverWaterLevel,
    settlement,
    crestLevelBoundaryCondition,
    hydraulicHeadBoundaryCondition,
    burstingParameterRevision,
    burstingParameter,
    baseSoilType,
    soilTypeRevision,
    soilType,
    suTable,
    suTablePoint,
    topoProfile,
    topoProfilePoint,
    stageConfiguration,
    stageConfigurationRevision,
    multiplePhreaticLine,
    phreaticLine,
    phreaticReferenceLine,
    multipleHeadLine,
    headLine,
    headReferenceLine,
    soilProfile,
    soilProfilePoint,
    soilLine,
    soilLayer,
    statePoints,
    years,
    userManagement,
    reinforcement,
    reinforcementGenerate,
    reinforcementPoint,
    overview,
    load,
    waterLineRule,
    waterLineRuleRevision,
    webSocket,
    comment
  },
  actions: {
    resetAllStates({ dispatch }) {
      // Dispatch resetState action for each module
      Object.keys(this._modules.root._children).forEach((moduleName) => {
        if (
          this._modules.root._children[moduleName]._rawModule.actions &&
          this._modules.root._children[moduleName]._rawModule.actions.resetState
        ) {
          dispatch(`${moduleName}/resetState`)
        }
      })
    }
  }
})

export default store
